<template>
<td v-bind="$attrs" style="text-align: center" @mouseleave="onCellFocusOut">
  <div>
    <button class="my-button" @click.stop="onClickAction" ref="button">
      {{ buttonName }}
      <base-icon size="xs" name="fullscreen" aria-hidden />
    </button>
  </div>
</td>

</template>
<script>
import { i18n } from '@/i18n'

export default {
  name: 'action-cell',
  inheritAttrs: false,
  components: {
  },
  data () {
    return {
      show: false,
      mouseOverPopup: false,
      idAccion: -1,
      buttonName: i18n.t('app.detail')
    }
  },
  mounted: function () {
    this.show = false
  },
  props: {
    dataItem: Object
  },
  methods: {
    onClick (e) {
      this.show = true
    },
    onClickAction (event) {
      const action = { idAccion: this.idAccion, label: this.buttonName }
      this.$emit('actionclick', { dataItem: this.dataItem, action, event })
      this.show = !this.show
    },
    onFocusOut (e) {
      this.show = false
      this.mouseOverPopup = false
    },
    onCellFocusOut (e) {
      setTimeout(() => {
        if (!this.mouseOverPopup) {
          this.show = false
        }
        this.mouseOverPopup = false
      })
    },
    onMouseEnter () {
      this.mouseOverPopup = true
    }
  }
}
</script>

<style scoped>
    .my-button {
        border-radius: 18px;
        background-color: transparent;
        color: var(--primary-800);
    }
    .dark .my-button{
      color: var(--primary-600);
    }

    .action {
        margin: 10px 20px 10px 20px;
        cursor: pointer
    }
</style>
